// Google Analytics 4 — replace G-XXXXXXXXXX with your real Measurement ID
// (must match the id in index.html gtag loader)
export const GA_MEASUREMENT_ID = 'G-2TC6PFGSVD';

export function trackPageView(path) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, { page_path: path });
  }
}

export function trackEvent(eventName, params = {}) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
}

// Product detail page view
export function trackViewItem(product) {
  trackEvent('view_item', {
    currency: 'GBP',
    value: product.price,
    items: [{
      item_id: product.sku || product.id,
      item_name: product.name,
      item_category: product.category,
      price: product.price,
      quantity: 1,
    }],
  });
}

// Add a product (sim rig / hardware) to cart
export function trackAddToCart(product, qty = 1) {
  trackEvent('add_to_cart', {
    currency: 'GBP',
    value: product.price * qty,
    items: [{
      item_id: product.sku || product.id,
      item_name: product.name,
      item_category: product.category,
      price: product.price,
      quantity: qty,
    }],
  });
}

// Add a booking experience to cart
export function trackAddBooking(booking) {
  trackEvent('add_to_cart', {
    currency: 'GBP',
    value: booking.price,
    items: [{
      item_id: booking.experience_type,
      item_name: booking.experience_name || booking.experience_type,
      item_category: 'booking',
      item_variant: booking.rig_type,
      price: booking.price,
      quantity: 1,
    }],
  });
}

function mapItems(items) {
  return items.map(i => i.type === 'booking'
    ? {
        item_id: i.experience_type,
        item_name: i.product_name || i.experience_type,
        item_category: 'booking',
        item_variant: i.rig_type,
        price: i.price,
        quantity: 1,
      }
    : {
        item_id: i.product_id,
        item_name: i.product_name,
        item_category: 'product',
        price: i.price,
        quantity: i.quantity,
      });
}

export function trackBeginCheckout(items, total) {
  trackEvent('begin_checkout', {
    currency: 'GBP',
    value: total,
    items: mapItems(items),
  });
}

export function trackPurchase(transactionId, items, total) {
  trackEvent('purchase', {
    transaction_id: transactionId,
    currency: 'GBP',
    value: total,
    items: mapItems(items),
  });
}

// Google Ads conversion — fired once on the order confirmation step so the
// AW-17779329710 ad account can attribute the sale. Value + currency are
// included so Google Ads can report ROAS; transaction_id de-duplicates.
export function trackAdsConversion(transactionId, value) {
  trackEvent('conversion', {
    send_to: 'AW-17779329710/BiHfCLXRoOgcEK6V7J1C',
    value: Number(value) || 0,
    currency: 'GBP',
    ...(transactionId ? { transaction_id: transactionId } : {}),
  });
}